export const PRODUCT_CATEGORY = {
  LIFE_SUITE: 'Life Suite',
  LIFE_EXPERIENCE: 'Life Experience',
} as const;

export const PRODUCT_DEFINITIONS = [
  {
    id: 75,
    name: 'Augmented Exposure',
    category: PRODUCT_CATEGORY.LIFE_SUITE,
  },
  {
    id: 76,
    name: 'Augmented Performance',
    category: PRODUCT_CATEGORY.LIFE_SUITE,
  },
  {
    id: 77,
    name: 'Augmented Wellbeing',
    category: PRODUCT_CATEGORY.LIFE_EXPERIENCE,
  },
  {
    id: 78,
    name: 'Augmented Situations',
    category: PRODUCT_CATEGORY.LIFE_EXPERIENCE,
  },
  {
    id: 79,
    name: 'Augmented Corporate',
    category: PRODUCT_CATEGORY.LIFE_EXPERIENCE,
  },
  {
    id: 80,
    name: 'Augmented Psychology',
    category: PRODUCT_CATEGORY.LIFE_EXPERIENCE,
  },
  {
    id: 81,
    name: 'Augmented Mentalization',
    category: PRODUCT_CATEGORY.LIFE_EXPERIENCE,
  },
] as const;

export const PRODUCTS = PRODUCT_DEFINITIONS.map(product => product.name);

export const PRODUCTS_BY_ID = PRODUCT_DEFINITIONS.reduce<
  Record<number, (typeof PRODUCT_DEFINITIONS)[number]>
>((accumulator, product) => {
  accumulator[product.id] = product;
  return accumulator;
}, {});

export const PRODUCTS_CONFIG = {
  PRODUCTS,
  PRODUCT_DEFINITIONS,
  PRODUCTS_BY_ID,
  PRODUCT_CATEGORY,
} as const;
